import { useMemo } from "react";

import { UploadFile } from "antd/es/upload/interface";

import File from "@mapmycustomers/shared/types/File";

import { complementFileUrl } from "@app/util/file";

const useProfilePhotoFileList = (isUploading: boolean, profilePhoto?: File): UploadFile[] =>
  useMemo(() => {
    if (isUploading) {
      return [
        {
          name: "",
          size: 0,
          status: "uploading",
          type: "",
          uid: "profilePhoto",
        },
      ];
    }
    if (profilePhoto?.publicURI) {
      return [
        {
          name: profilePhoto.name,
          size: profilePhoto.contentLength ?? 0,
          status: "done",
          type: profilePhoto.contentType,
          uid: "profilePhoto",
          url: complementFileUrl(profilePhoto.publicURI),
        },
      ];
    }
    return [];
  }, [isUploading, profilePhoto]);

export default useProfilePhotoFileList;
